<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="status$ | async as status">
    <div class="tab-container" [class.tab-container--loading]="status.loading">
      <div *ngIf="status.loading">
        <df-spinner [isSpinning]="status.loading"></df-spinner>
      </div>

      <ng-container *ngIf="!status.loading">
        <ul class="guts-p-b-1 guts-m-l-3" data-dgat="following-tab-a95">
          <li
            *ngFor="let followee of vm.followees; let first = first"
            class="
              l_flex
              m-l_flex
              l_flex-justify
              border-bottom
              guts-m-b-1 guts-p-b-1 guts-p-r-1
            "
            [class.guts-p-t-2]="first"
            data-dgat="following-tab-bd4"
          >
            <div class="l_flex m-l_flex l_flex-middle l_flex-grow">
              <dgx-profile-pic
                [profile]="followee.userProfile"
                [size]="'tiny'"
                class="guts-p-r-1"
              ></dgx-profile-pic>
              <div
                role="button"
                class="item-link"
                data-dgat="followers-tab-92c"
                (click)="goToProfile(followee.userProfile)"
              >
                {{ followee.userProfile.name }}
              </div>
            </div>

            <div
              class="l_flexbar l_flex-shrink"
              *ngIf="followee?.userProfile?.userProfileId !== authUserId"
            >
              <span
                class="guts-m-r-half par--light ib"
                [attr.aria-label]="i18n.UserController_ThisUserPrivate"
                tabindex="0"
                *ngIf="!followee.viewerCanFollow"
                [ngbTooltip]="i18n.UserController_ThisUserPrivate"
                container="body"
                trigger="focus mouseenter"
              >
                <df-icon icon="lock-closed"></df-icon>
              </span>
              <dgx-follow-user-button
                class="ib"
                *ngIf="
                  followee.viewerCanFollow ||
                  isViewersFollowee(followee?.userProfile?.userProfileId)
                "
                [hasPromise]="true"
                [isActive]="
                  isViewersFollowee(followee?.userProfile?.userProfileId)
                "
                [submitting]="followee.submitting"
                (onToggle)="setFollowUser($event, followee)"
                [showFollowingLabel]="true"
              >
              </dgx-follow-user-button>
            </div>
          </li>
        </ul>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
